var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "materialScience" }, [
    _vm._m(0),
    _c("div", { staticClass: "cont" }, [
      _c("h1", { staticClass: "cont-title" }, [_vm._v("申报材料")]),
      _c("div", { staticClass: "cont-item" }, [
        _c("div", { staticClass: "item-title" }, [
          _vm._v("（一）学士学位备案表一份。"),
        ]),
        _c(
          "div",
          { staticClass: "imgs" },
          [
            _c("el-image", {
              staticClass: "img",
              attrs: {
                src: require("../../../assets/images/degreeApplication/application.png"),
                fit: "contain",
                "preview-src-list": [
                  require("../../../assets/images/degreeApplication/application.png"),
                ],
              },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "cont-item" }, [
        _c("div", { staticClass: "item-title" }, [
          _vm._v("（二）毕业证扫描件一份。"),
        ]),
        _c(
          "div",
          { staticClass: "imgs" },
          [
            _c("el-image", {
              staticClass: "img",
              attrs: {
                src: require("../../../assets/images/degreeApplication/diploma.jpg"),
                fit: "contain",
                "preview-src-list": [
                  require("../../../assets/images/degreeApplication/diploma.jpg"),
                ],
              },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "cont-item" }, [
        _c("div", { staticClass: "item-title" }, [
          _vm._v("（三）英语考试如下材料之一："),
        ]),
        _c("div", { staticClass: "item-text" }, [
          _vm._v("1、全国大学英语四级及以上考试，成绩>350分；"),
        ]),
        _c(
          "div",
          { staticClass: "imgs" },
          [
            _c("el-image", {
              staticClass: "img",
              attrs: {
                src: require("../../../assets/images/degreeApplication/englishExam1.png"),
                fit: "contain",
                "preview-src-list": [
                  require("../../../assets/images/degreeApplication/englishExam1.png"),
                ],
              },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "item-text" }, [
          _vm._v("2、全国英语等级考试（PETS）三级及以上，笔试成绩合格；"),
        ]),
        _c(
          "div",
          { staticClass: "imgs" },
          [
            _c("el-image", {
              staticClass: "img",
              attrs: {
                src: require("../../../assets/images/degreeApplication/englishExam2.png"),
                fit: "contain",
                "preview-src-list": [
                  require("../../../assets/images/degreeApplication/englishExam2.png"),
                ],
              },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "item-text" }, [
          _vm._v("3、医学英语水平考试（METS）三级及以上，成绩合格；"),
        ]),
        _c(
          "div",
          { staticClass: "imgs" },
          [
            _c("el-image", {
              staticClass: "img",
              attrs: {
                src: require("../../../assets/images/degreeApplication/englishExam3.png"),
                fit: "contain",
                "preview-src-list": [
                  require("../../../assets/images/degreeApplication/englishExam3.png"),
                ],
              },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "cont-item" }, [
        _c("div", { staticClass: "item-title" }, [
          _vm._v(
            "（四）全国计算机等级考试（NCRE）合格证扫描件一份。（附考试时间、考试科目备查）"
          ),
        ]),
        _c(
          "div",
          { staticClass: "imgs" },
          [
            _c("el-image", {
              staticClass: "img",
              attrs: {
                src: require("../../../assets/images/degreeApplication/certificateConformity.jpg"),
                fit: "contain",
                "preview-src-list": [
                  require("../../../assets/images/degreeApplication/certificateConformity.jpg"),
                ],
              },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "cont-item" }, [
        _c("div", { staticClass: "item-title" }, [
          _vm._v("（五）毕业生总成绩单如下之一："),
        ]),
        _c("div", { staticClass: "item-text" }, [
          _vm._v(" 1、成教毕业生成绩总表一份； "),
        ]),
        _c(
          "div",
          { staticClass: "imgs" },
          [
            _c("el-image", {
              staticClass: "img",
              attrs: {
                src: require("../../../assets/images/degreeApplication/cjchengji.jpg"),
                fit: "contain",
                "preview-src-list": [
                  require("../../../assets/images/degreeApplication/cjchengji.jpg"),
                ],
              },
            }),
          ],
          1
        ),
      ]),
      _vm._m(1),
      _vm._m(2),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "top" }, [
      _c("img", {
        staticClass: "materialScience-img",
        attrs: {
          src: require("../../../assets/images/degreeApplication/materialScience.png"),
          alt: "",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "cont-item" }, [
      _c("div", { staticClass: "item-title" }, [
        _vm._v("（六）身份证复印件一份。"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "cont-item" }, [
      _c("div", { staticClass: "item-title" }, [
        _vm._v("（七）纸质小二寸照片2张（姓名及身份证号写背面），"),
      ]),
      _c("div", { staticClass: "item-tips" }, [
        _c("p", [_vm._v("注意：")]),
        _c("p", [
          _vm._v(" 1、纸质小2寸照片，必须与本科毕业证照片一致。（ "),
          _c("span", { staticClass: "color-red" }, [_vm._v("毕业证照片可在")]),
          _c(
            "a",
            { attrs: { href: "https://www.chsi.com.cn/", target: "_blank" } },
            [_c("span", { staticClass: "color-blue" }, [_vm._v("学信网")])]
          ),
          _c("span", { staticClass: "color-red" }, [_vm._v("上截取")]),
          _vm._v(" ） "),
        ]),
        _c("p", [
          _vm._v("2、电子照片（必须命名为 张 三 513132199210121028.jpg）， "),
          _c("span", { staticClass: "color-red" }, [
            _vm._v(
              "电子照片大小为10一40KB且像素尺寸为（宽）480*（高）640，图片必须用jpg格式"
            ),
          ]),
          _vm._v("。电子照片在网上申报时提交。"),
        ]),
        _c("p", [
          _vm._v(
            "3、申请学位所需电子照片格式不符合要求者，将无法完成学位信息网上报送工作！"
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }